import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IRetornoBotao } from '../../interface/icm-retorno-botao';
import { IColunaTextoBotoes } from '../../interface/icm-texto-botoes-generico';

@Component({
    selector: 'icm-coluna-texto-botoes',
    templateUrl: './view/icm-coluna-texto-botoes.component.html',
    styleUrls: ['./view/icm-coluna-texto-botoes.component.scss'],
})
export class IcmColunaTextoBotoesComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaTextoBotoes;
    @Input() carregando: boolean;

    @Output() emitirClicado = new EventEmitter<IRetornoBotao<any>>();

    texto: string | number | Date;
    corTexto: string = '#000000de';
    corDesabilitado: string = '#00000042';

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.texto = this.coluna.texto(this.linha);
    }
}
